<template>
  <v-list-item dense active-class="white" @click="$emit('click',item)" three-line color="issue" link>
    <v-list-item-action v-if="!hideIcon">
      <v-icon v-if="!isTask">mdi-email</v-icon>
      <v-icon v-else> mdi-check </v-icon>
      <span style="font-size: 0.8em">#{{ item.Issue_ID }} </span>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-if="!hideProjectName">
        <strong> {{ item.BranchAddress }}</strong>
      </v-list-item-title>
      <p class="text--grey pb-1" >
        {{ item.IssueTitle | emptyString }}
      </p>
      <v-list-item-subtitle style="border-top:1px solid #eeeeee" class="pt-1">
        <strong> {{lastResponse.Senter }}: </strong> {{ lastResponse.ActionNotes | emptyString }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <slot name="aboveDate"></slot>
      <v-list-item-action-text v-if="!hideTime">{{ lastResponse.DateInsert | time }}</v-list-item-action-text>
      <span v-if="!fullDate">{{ lastResponse.DateInsert| date }}</span>
      <span v-else> {{ lastResponse.DateInsert| fullDate }}</span>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import {Issue} from "../../../wl-core/api/classes/Issue";

export default {
  name: "IssueItem",
  props: {
    item: Issue,
    isTask:Boolean,
    hideProjectName:Boolean,
    hideTime:Boolean,
    fullDate:Boolean,
    hideIcon:Boolean,
  },
  computed: {
    lastResponse(){
      return this.item.getLastAction()
    }
  }
}
</script>

<style scoped>

</style>
